// extracted by mini-css-extract-plugin
export var actionButton = "_s9-0";
export var actionMenuContainer = "_s9-i";
export var bubble = "_s9-2";
export var bubbleActionMenu = "_s9-j";
export var bubbleContext = "_s9-6";
export var bubbleItems = "_s9-7";
export var customer = "_s9-3";
export var divider = "_s9-8";
export var fileList = "_s9-9";
export var hiddenComment = "_s9-o";
export var infoAbove = "_s9-a";
export var internal = "_s9-4";
export var lightActionButton = "_s9-1";
export var link = "_s9-b";
export var merchant = "_s9-5";
export var message = "_s9-c";
export var profilePicture = "_s9-e";
export var quillToolbarContainer = "_s9-f";
export var senderDate = "_s9-g";
export var senderDateCustomer = "_s9-h";
export var senderName = "_s9-d";
export var time = "_s9-k";
export var uploadedImage = "_s9-l";
export var username = "_s9-m";
export var xsmall = "_s9-n";